if (!customElements.get('quick-nav')) {
  class QuickNav extends HTMLElement {
    constructor() {
      super();
      this.childSelect = this.querySelector('custom-select[data-level="2"]');
      this.grandchildSelect = this.querySelector('custom-select[data-level="3"]');
      this.submitButton = this.querySelector('.js-submit');
      this.priceRange = this.querySelector('.js-quick-nav-price');
      
      this.currentCategoryUrl = '/collections/all';

      this.addEventListener('change', this.handleQuickNavChange.bind(this));
      this.addEventListener('click', this.handleQuickNavClick.bind(this));

      // Start the hidden initialization
      this.initWidget();
    }

    async initWidget() {
      // Set the initial URL so it's clickable immediately
      this.submitButton.href = this.currentCategoryUrl;
      this.submitButton.removeAttribute('aria-disabled');
      
      // Fetch the count
      await this.parseCollectionInfo(this.currentCategoryUrl);
      
      this.classList.add('is-loaded');
    }

    handleQuickNavClick(evt) {
      // If clicking the button itself, ensure we don't prevent the link from opening
      if (evt.target.closest('.js-submit')) {
        return; 
      }

      const slideshowElem = this.closest('slide-show');
      if (slideshowElem && slideshowElem.dataset.autoplay === 'true') {
        const autoplayBtn = slideshowElem.querySelector('.autoplay-btn');
        if (autoplayBtn) autoplayBtn.click();
      }
    }

    handleQuickNavChange(evt) {
      if (evt.target.matches('custom-select') && evt.detail.selectedValue) {
        const selectedOption = evt.target.querySelector('[aria-selected="true"]');
        this.currentCategoryUrl = selectedOption.dataset.url;
        
        this.updateFinalState();

        if (evt.target.dataset.level === '1' && this.childSelect) {
          QuickNav.prepareSelect(this.childSelect, evt.detail.selectedValue);
          QuickNav.resetSelect(this.grandchildSelect, true);
        } else if (evt.target.dataset.level === '2' && this.grandchildSelect) {
          QuickNav.prepareSelect(this.grandchildSelect, evt.detail.selectedValue);
        }
      } 
      else if (evt.target.closest('.price-range')) {
        this.updateFinalState();
      }
    }

    updateFinalState() {
      const minInput = this.querySelector("[name='filter.v.price.gte']");
      const maxInput = this.querySelector("[name='filter.v.price.lte']");
      
      let baseUrl = this.currentCategoryUrl.split('?')[0];
      let finalUrl = baseUrl;

      if (minInput && maxInput) {
        finalUrl = `${baseUrl}?filter.v.price.gte=${minInput.value}&filter.v.price.lte=${maxInput.value}`;
      }

      this.submitButton.href = finalUrl;
      this.submitButton.removeAttribute('aria-disabled'); // Keep it clickable
      
      this.parseCollectionInfo(finalUrl);
    }

    async parseCollectionInfo(url) {
      // We removed aria-disabled=true from here so the button stays active
      this.submitButton.classList.add('is-loading');

      try {
        const response = await fetch(url);
        if (response.ok) {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();
          const productsContainer = tmpl.content.querySelector('[data-num-results]');
          const buttonText = this.submitButton.querySelector('.js-button-text') || this.submitButton;

          if (productsContainer) {
            const count = parseInt(productsContainer.dataset.numResults, 10);
            if (count === 0) {
              buttonText.textContent = "No tools found";
            } else if (count === 1) {
              buttonText.textContent = "Show 1 Tool";
            } else {
              buttonText.textContent = `Show ${count} Tools`;
            }
          }

          const newPriceRange = tmpl.content.querySelector('price-range');
          if (newPriceRange && this.priceRange && !url.includes('filter.v.price')) {
            this.priceRange.innerHTML = newPriceRange.outerHTML;
            this.priceRange.style.maxHeight = 'none';
            this.priceRange.style.display = 'block';
          }
        }
      } catch (error) {
        console.error("QuickNav Error:", error);
      }

      this.submitButton.classList.remove('is-loading');
    }

    static prepareSelect(selectElem, value) {
      let hasOptions = false;
      let counter = 0;
      selectElem.querySelectorAll('.custom-select__option:not(.quick-nav__default-option)').forEach((link) => {
        if (link.dataset.parentHandle === value) {
          hasOptions = true;
          link.style.display = '';
          counter++;
        } else {
          link.style.display = 'none';
        }
      });
      
      const listbox = selectElem.querySelector('.quick-nav__listbox');
      if (listbox) listbox.setAttribute('data-link-count', counter < 5 ? counter : 'loads');
      
      QuickNav.resetSelect(selectElem, !hasOptions);
      if (hasOptions) selectElem.querySelector('.custom-select__btn').removeAttribute('disabled');
    }

    static resetSelect(selectElem, disable) {
      if (selectElem) {
        const label = selectElem.querySelector('.custom-select__btn span');
        if (label && label.dataset.defaultText) {
            label.textContent = label.dataset.defaultText;
        }
        if (disable) {
          selectElem.querySelector('.custom-select__btn').setAttribute('disabled', 'disabled');
        }
      }
    }
  }
  customElements.define('quick-nav', QuickNav);
}